<template>
  <div>
    <Spinner v-if="loading"/>
    <div v-else>
      <div
          class="continue-reading"
          v-if="books && books.length > 0"
      >
        <h3>Verder lezen</h3>
        <p>
          Met de onderstaande boeken ben je al begonnen, dus lees snel verder. Eet smakelijk!
        </p>

        <router-link
            v-for='(book, index) in books'
            :key='index'
            class='book'
            :to="{
                name: 'pages.book',
                params: {id: book.id},
                query: {page: book.current_page}
            }"
        >
          <img :src="baseUrl + '/storage/' + book.cover" alt="Cover image">

          <div class="info">
            <div class="rating">
              <span class="star"></span>
              <span class="star"></span>
              <span class="star"></span>
              <span class="star"></span>
              <span class="star"></span>
            </div>

            <h4>{{ book.name }}</h4>
            <span class="author light">Door {{ book.author }}</span>
          </div>

          <div class="percentage">
            {{ book.completion_percentage }} %
          </div>
        </router-link>
      </div>

      <div v-else>
        <div class="cta-card">
          <h3>Beginnen maar!</h3>
          <p class="light">Zodra je aan jouw eerste boek bent begonnen kun je dat hier snel terug vinden. Voor nu kun je de onderstaande knop gebruiken om naar jouw boekenplank te gaan!</p>
          <router-link
              class="btn"
              :to="{name: 'pages.books'}"
          >
            Naar de boekenplank
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import {baseUrl} from '@/http/utl.js';
import Spinner from "../../blocks/Spinner.vue";

export default {
  name: "ContinueReading",
  data() {
    return {
      books: [],
      baseUrl: baseUrl,
      loading: true,
    };
  },
  components: {
    Spinner,
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("book", [
      "getStartedBooks",
    ]),
    init() {
      this.getStartedBooks().then(response => {
        this.books = response;
        this.loading = false;
      });
    },
  },
};
</script>
